"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { useSupabase } from "@/lib/supabase/context"

export function BlogCTA() {
  const [user, setUser] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(true)
  const supabase = useSupabase()

  useEffect(() => {
    const loadUser = async () => {
      try {
        const {
          data: { user },
          error,
        } = await supabase.auth.getUser()
        
        // Silently handle missing sessions - completely normal for unauthenticated users
        if (error) {
          const errorMessage = error.message || ''
          if (errorMessage.includes('Invalid Refresh Token') || 
              errorMessage.includes('Refresh Token Not Found') ||
              errorMessage.includes('refresh token') ||
              errorMessage.includes('Auth session missing') ||
              errorMessage.includes('AuthSessionMissingError')) {
            setUser(null)
            setIsLoading(false)
            return
          }
        }
        
        setUser(user || null)
      } catch (error: any) {
        // Silently handle expected "no session" errors
        const errorMessage = error?.message || ''
        if (errorMessage.includes('Invalid Refresh Token') || 
            errorMessage.includes('Refresh Token Not Found') ||
            errorMessage.includes('refresh token') ||
            errorMessage.includes('Auth session missing') ||
            errorMessage.includes('AuthSessionMissingError')) {
          setUser(null)
        }
      } finally {
        setIsLoading(false)
      }
    }
    loadUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Don't show CTA for logged-in users
  if (isLoading || user) {
    return null
  }

  return (
    <section className="mt-16 p-8 bg-muted/30 rounded-lg text-center">
      <h3 className="text-2xl font-bold mb-4">Ready to Transform Your Planning?</h3>
      <p className="text-muted-foreground mb-6">
        Start your journey with Dream Planner and bring these principles to life.
      </p>
      <Link href="/auth/sign-up">
        <Button>Start Planning Free</Button>
      </Link>
    </section>
  )
}

